import React from "react";
import Button from "../../atoms/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import { apiGet } from "../../../services/api/generic.api";
import classNames from "classnames";
import { Check } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface PricingCardProps {
  title: string;
  price: number;
  features: string[];
  isPopular?: boolean;
  tier: string;
  active?: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  price,
  features,
  isPopular = false,
  tier,
  active = false,
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.settings.user);
  const { t } = useTranslation();

  const handleSubscribe = async () => {
    apiGet(
      dispatch,
      `/api/user/subscription?userID=${user?.userID}&customerID=${user?.stripeID}&tier=${tier}`
    ).then((res: any) => {
      const url = res.result;
      window.location.href = url;
    });
  };

  const className = classNames("dui-pricing-card", {
    popular: isPopular,
    active: active,
  });
  return (
    <div className={className}>
      <div className="dui-pricing-card-header">
        <h3 className="dui-pricing-card-title">{title}</h3>
        <div className="dui-pricing-card-price">
          <span className="amount">{price}</span>
          <span className="currency">€</span>
          <span className="period">/ {t("monthUnit")}</span>
        </div>
      </div>

      <div className="dui-pricing-card-content">
        <ul className="dui-pricing-card-features">
          {features.map((feature, index) => (
            <li key={index} className="dui-pricing-card-feature">
              {feature}
            </li>
          ))}
        </ul>
        {active ? (
          <Button
            corners="rounded"
            className="dui-pricing-card-button"
            appearance="error"
            onClick={handleSubscribe}
          >
            {t("cancelSubscription")}
          </Button>
        ) : (
          <Button
            className="dui-pricing-card-button"
            corners="rounded"
            onClick={handleSubscribe}
          >
            {t("choose")} {title}
          </Button>
        )}
      </div>
      {active && (
        <div className="dui-pricing-card-check">
          <Check />
        </div>
      )}
    </div>
  );
};

export default PricingCard;
